<div class="container-fluid px-5 py-3">
    <div class="d-flex justify-content-between pb-2">
        <span class="text-blue font-weight-bold">
            <h3 translate>suspiciousTechnicalInspection.title</h3>
        </span>
    </div>

    <!-- Search Form -->
    <form [formGroup]="searchForm" (ngSubmit)="onSubmitSearchForm()">
        <div class="input-group mb-2">
            <!-- reg number -->
            <div class="input-group-prepend">
                <span class="input-group-text" id="registrationNumber" translate>suspiciousTechnicalInspection.regNumber</span>
            </div>
            <input style="text-transform:uppercase" type="text" class="form-control" (keyup.enter)="onSubmitSearchForm()"
                   formControlName="registrationNumber" aria-describedby="registrationNumber" appTrimWhitespace>

            <!-- from date -->
            <div class="input-group-prepend ml-2">
                <span class="input-group-text" id="startDate" translate>suspiciousTechnicalInspection.fromDate</span>
            </div>
            <input class="form-control d-inline" style="max-width: 250pt;" aria-describedby="fromDateSearch"
                   formControlName="fromDateSearch" ngbDatepicker #d1="ngbDatepicker" readonly>
            <div class="input-group-append">
                <button class="btn btn-outline-secondary fa fa-calendar" (click)="d1.toggle()" type="button"></button>
            </div>

            <!-- to date -->
            <div class="input-group-prepend ml-2">
                <span class="input-group-text" id="endDate" translate>suspiciousTechnicalInspection.toDate</span>
            </div>
            <input class="form-control d-inline" style="max-width: 250pt;" aria-describedby="toDateSearch"
                   formControlName="toDateSearch" ngbDatepicker #d2="ngbDatepicker" readonly>
            <div class="input-group-append">
                <button class="btn btn-outline-secondary fa fa-calendar" (click)="d2.toggle()" type="button"></button>
            </div>

            <!-- resolved filter -->
            <div class="input-group-prepend ml-2">
                <span class="input-group-text" id="resolvedFilter" translate>suspiciousTechnicalInspection.resolvedFilter</span>
            </div>
            <select class="custom-select" style="max-width: 200pt;" aria-describedby="resolvedFilter"
                    formControlName="resolvedFilter" (change)="onSubmitSearchForm()">
                <option *ngFor="let option of resolvedFilterOptions" [value]="option">
                    {{'suspiciousTechnicalInspection.resolvedFilterOption.' + option | translate}}
                </option>
            </select>

            <!-- actions -->
            <div class="input-group-append ml-2 action-buttons">
                <button class="btn btn-outline-success" type="button" (click)="onSubmitSearchForm()" [disabled]="loadPdfOrExcel" translate>button.search</button>
                <button class="btn btn-outline-danger ml-2" type="button" (click)="clearFilters()" [disabled]="loadPdfOrExcel" translate>button.clear</button>
                <ng-container *ngIf="!loadPdfOrExcel; else pleaseWait">
                    <i class="fa fa-file-excel-o fa-2x ml-2 mt-1" data-toggle="tooltip" data-placement="bottom" title="{{'button.excel' | translate}}" (click)="exportExcel()"></i>
                    <i class="fa fa-file-pdf-o fa-2x ml-2 mt-1" data-toggle="tooltip" data-placement="bottom" title="{{'button.pdf' | translate}}" (click)="exportPDF()"></i>
                </ng-container>
                <ng-template #pleaseWait>
                    <span class="pleaseWait" translate>placeholder.wait</span>
                </ng-template>
            </div>
        </div>
    </form>

    <br>

    <!-- Table -->
    <div class="d-flex justify-content-center">
        <table class="table table-bordered table-striped w-100 mt-2" [hidden]="!dataLoaded">
            <thead>
                <tr>
                    <th sortBy="technicalPointShortName" (sort)="onSubmitSearchFormSort($event)" translate>suspiciousTechnicalInspection.technicalPoint</th>
                    <th sortBy="createdDate" (sort)="onSubmitSearchFormSort($event)" translate>suspiciousTechnicalInspection.createdDate</th>
                    <th sortBy="regNumber" (sort)="onSubmitSearchFormSort($event)" translate>suspiciousTechnicalInspection.regNumber</th>
                    <th sortBy="reservationFinishedTimestamp" (sort)="onSubmitSearchFormSort($event)" translate>suspiciousTechnicalInspection.reservationFinished</th>
                    <th sortBy="lastCheck" (sort)="onSubmitSearchFormSort($event)" translate>suspiciousTechnicalInspection.lastCheck</th>
                    <th translate>suspiciousTechnicalInspection.nextInspectionDate</th>
                    <th translate>suspiciousTechnicalInspection.resolvedAt</th>
                    <th translate>suspiciousTechnicalInspection.resolvedByRegNumber</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of suspiciousInspections">
                    <td class="text-center py-2">{{item.technicalPointShortName}}</td>
                    <td class="text-center py-2">{{item.technicalInspectionCreatedDate}}</td>
                    <td class="text-center py-2">{{item.regNumber}}</td>
                    <td class="text-center py-2">{{item.reservationFinishedTimestamp}}</td>
                    <td class="text-center py-2">{{item.lastCheck}}</td>
                    <td class="text-center py-2">{{item.nextInspectionDate}}</td>
                    <td class="text-center py-2">{{item.resolvedAt}}</td>
                    <td class="text-center py-2">{{item.resolvedByRegNumber}}</td>
                </tr>
            </tbody>
        </table>
    </div>

    <!-- Pagination -->
    <div class="paging-wrapper d-flex justify-content-between">
        <select class="pagination-size custom-select" [(ngModel)]="sortingPaging.pageSize" (ngModelChange)="loadSuspiciousInspections()">
            <option *ngFor="let item of pageSizeOptions; let i = index" [value]="pageSizeOptions[i]">
                {{pageSizeOptions[i]}} {{'paging.itemsPerPage' | translate}}
            </option>
        </select>
        <ngb-pagination class="pagination-control"
            [(page)]="sortingPaging.pageNumber"
            [pageSize]="sortingPaging.pageSize"
            [collectionSize]="sortingPaging.totalElements"
            [boundaryLinks]="true"
            [maxSize]="maxSize"
            (pageChange)="pageChanged($event)">
        </ngb-pagination>
        <span class="pagination-index border center">
            {{sortingPaging.fromRow}} - {{sortingPaging.toRow}} / {{sortingPaging.totalElements}}
        </span>
    </div>
</div>
